import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DfAmadeusLogoComponent } from '@design-factory/design-factory';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { NavBarComponent } from './navbar.component';
import { PreferencesComponent } from './preferences.component';

/**
 * Container including the Toolbar and the NavBar.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "ama-ng-appbar",
  standalone: true,
  imports: [
    PreferencesComponent,
    NavBarComponent,
    NgbCollapse,
    DfAmadeusLogoComponent
  ],
  templateUrl: "appbar-container.component.html"
})
export class AppBarComponent {
  @Input() section!: string;
  @Input() numberNewApps!: number;
  navbarCollapsed = true;
}
